import { Link } from 'react-router-dom';
export default Link;


//////////////////
// WEBPACK FOOTER
// /Users/shuai/Documents/github/ant-design-pro-site/scaffold/node_modules/_umi@2.6.8@umi/lib/link.js
// module id = 1158
// module chunks = 0